import React from 'react';
import { PlayPauseBlanket as EmotionPlayPauseBlanket } from './playPauseBlanket-emotion';
import { PlayPauseBlanket as CompiledPlayPauseBlanket } from './playPauseBlanket-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var PlayPauseBlanket = function PlayPauseBlanket(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledPlayPauseBlanket, props) : /*#__PURE__*/React.createElement(EmotionPlayPauseBlanket, props);
};